import store from 'store';
export const getDefaultCampignReqConfig =  () => {
    const state = store.getState();
    const campaignReferrerPage = state.commonData?.userProfile?.refererPage;   
    const ctaId = state.commonData?.userProfile?.ctaId;
    const utmId = state.commonData?.userProfile?.utmId;
    const utmCampaign = state.commonData?.userProfile?.utmCampaign;
    const utmMedium = state.commonData?.userProfile?.utmMedium;
    const utmSource = state.commonData?.userProfile?.utmSource;
    const utmContent = state.commonData?.userProfile?.utmContent;
    const utmTerm = state.commonData?.userProfile?.utmTerm;
    const delimiter = '~';
    const requestConfig =   {
        campaignReferrerPage,
        ctaId,
        utmId,
        utmCampaign,
        utmMedium,
        utmSource,
        utmContent,
        utmTerm,
        // requestId,
        // uniqueId,
          }

          const requestConfigString = Object.values(requestConfig).join(delimiter);
          return requestConfigString;
        };